import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const PowerBi = () => {
    const iframeRef = useRef(null);
    const { company } = useSelector((state) => state.company);
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { paidMediaSummary } = dtcData;
    const { totalPaidMediaSummary } = paidMediaSummary;
    const [urls, setUrls] = useState({
        publicUrl: '',
        reportUrl: '',
    });
    const adjustIframeHeight = () => {
        const iframe = iframeRef.current;
        if (iframe) {
            try {
                iframe.style.height =
                    iframe.contentWindow.document.body.scrollHeight + 'px';
            } catch (error) {
                console.error('Error adjusting iframe height:', error.message);
            }
        }
    };
    const powerBIUrl =
        'https://app.powerbi.com/view?r=eyJrIjoiNjNhNTA5YTktNjhjNC00NzE5LTk2OWYtOWQxMmU5MWJlNTVmIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection';
    const handlePowerBILinks = () => {
        let publicUrl =
            'https://app.powerbi.com/view?r=eyJrIjoiNjNhNTA5YTktNjhjNC00NzE5LTk2OWYtOWQxMmU5MWJlNTVmIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection';
        let reportUrl =
            'https://app.powerbi.com/view?r=eyJrIjoiMmFkZDQyNzUtZjA0MC00NTE1LWFlNjgtNDliZGViODdkMDA0IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection';
        switch (company.id) {
            case 150:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiMjg3YjM0Y2UtZGUwZi00MmY4LWJjNjEtOTMwN2FiNWQ3NTdlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiMjg3YjM0Y2UtZGUwZi00MmY4LWJjNjEtOTMwN2FiNWQ3NTdlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 165:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiMjg3YjM0Y2UtZGUwZi00MmY4LWJjNjEtOTMwN2FiNWQ3NTdlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiMjg3YjM0Y2UtZGUwZi00MmY4LWJjNjEtOTMwN2FiNWQ3NTdlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 61:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiZGFiMzZhMzAtODYxYy00MjY3LWI4OWYtZTNmODM4OGFlOWMwIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiZGFiMzZhMzAtODYxYy00MjY3LWI4OWYtZTNmODM4OGFlOWMwIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 64:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiN2U1MjI0NTgtMmUwMC00ZGMzLTljM2UtNGM5MDJhZTljMjRhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiN2U1MjI0NTgtMmUwMC00ZGMzLTljM2UtNGM5MDJhZTljMjRhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 94:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiM2ZjYjNmYmEtNzlhZC00NjBmLWEyNWYtZjU1MTU2NjE4NDE1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiM2ZjYjNmYmEtNzlhZC00NjBmLWEyNWYtZjU1MTU2NjE4NDE1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 104:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiYTYyZjcwYzgtZmIyNC00ZWE1LTlhM2UtNDBiN2VkNTM4YjJhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiYTYyZjcwYzgtZmIyNC00ZWE1LTlhM2UtNDBiN2VkNTM4YjJhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 105:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiZDU0YmNjODUtNDEyMC00ZjBhLTliOTEtMjA4MWExNjE2ZjA4IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiZDU0YmNjODUtNDEyMC00ZjBhLTliOTEtMjA4MWExNjE2ZjA4IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 110:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiNmZlMTJjNDUtYjc5MC00MThmLTgzYmEtZDgzZjE4ZmFiNWYwIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiNmZlMTJjNDUtYjc5MC00MThmLTgzYmEtZDgzZjE4ZmFiNWYwIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            case 118:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiMWJlMTkzNmUtYjQxZC00MGY0LTliNzQtOGNjY2M3OWUzMWFiIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiMWJlMTkzNmUtYjQxZC00MGY0LTliNzQtOGNjY2M3OWUzMWFiIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
            default:
                publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiODlmOThmMWItNzJkNy00Mjc5LWJkNjctY2RjMWNiMDZiY2MzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiODlmOThmMWItNzJkNy00Mjc5LWJkNjctY2RjMWNiMDZiY2MzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
                break;
        }
        setUrls({
            publicUrl: publicUrl,
            reportUrl: reportUrl,
        });
    };

    useEffect(() => {
        if (company.id) {
            handlePowerBILinks();
        }
    }, [company.id]);

    return (
        <>
            {totalPaidMediaSummary > 0 && (
                <Box>
                    <Divider className="mv-24 border-1-gray" />
                    <Box>
                        <Typography className="text-center text-lg-semi-bold gray-900">
                            Paid Media Engagement Metrics
                        </Typography>
                    </Box>
                    <Box
                        className={'bg-white border-softer mt-5 mb-5'}
                        sx={{ height: '100vh' }}
                    >
                        {powerBIUrl !== urls?.publicUrl ? (
                            <iframe
                                allowFullScreen="true"
                                ref={iframeRef}
                                src={urls?.reportUrl}
                                style={{
                                    height: '100vh',
                                    width: '100%',
                                    border: 'none',
                                }}
                                title=""
                                onLoad={adjustIframeHeight}
                            />
                        ) : (
                            <iframe
                                allowFullScreen="true"
                                ref={iframeRef}
                                src={urls?.publicUrl}
                                style={{
                                    height: '100vh',
                                    width: '100%',
                                    border: 'none',
                                }}
                                title=""
                                onLoad={adjustIframeHeight}
                            />
                        )}
                    </Box>
                </Box>
            )}
        </>
    );
};

export default PowerBi;
